import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
export const ProtectedRoute: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const {
    isAuthenticated
  } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace data-id="element-122" />;
  }
  return <>{children}</>;
};